(() => {
  if (window.KoffylandCartUpsellInitialized) return;
  window.KoffylandCartUpsellInitialized = true;

  const handleUpsellAdd = async (button) => {
    if (button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    const productId = button.dataset.productId;
    const productPrice = Number(button.dataset.productPrice);
    const label = button.querySelector('[data-kl-shipping-upsell-label]');
    if (!variantId || !label) return;

    const setLabel = (state) => {
      label.textContent = button.dataset[`label${state}`] || button.dataset.labelDefault;
    };

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setLabel('Loading');

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const buttonIsInDrawer = Boolean(button.closest('cart-drawer'));
      const sections = cartDrawer
        ? cartDrawer.getSectionsToRender().map((entry) => entry.id)
        : ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const cartState = await response.json();

      if (!response.ok || cartState.status) {
        throw new Error(cartState.description || cartState.message || 'Cart error');
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'kl_shipping_upsell_added',
        product_id: productId,
        product_price: productPrice,
        source: buttonIsInDrawer ? 'cart_drawer' : 'cart_page',
      });

      setLabel('Success');
      if (cartDrawer && buttonIsInDrawer && cartState.sections) {
        cartDrawer.setActiveElement(button);
        cartDrawer.renderContents(cartState);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      setLabel('Error');
      window.setTimeout(() => setLabel('Default'), 2200);
      button.disabled = false;
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kl-shipping-upsell-add]');
    if (button) handleUpsellAdd(button);
  });
})();
